export const markupDescription = (description: string): {__html: string} => {
  return {__html: description};
};
